/**
 * Converts a string to sentence case by capitalizing only the first letter.
 *
 * Examples:
 * - "hello world" -> "Hello world"
 * - "THE QUICK BROWN FOX" -> "The quick brown fox"
 *
 * @param str - The string to format
 * @returns The string with only the first letter capitalized
 */
const formatSentenceCase = (str: string): string => {
  if (str.length === 0) return str;
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export default formatSentenceCase;
